const mockPost = {
  title: "The future of second-hand EVs",
  date: "2023-06-13",
  image: "https://picsum.photos/1920/1080?random=13",
  content: [
    {
      heading: "Introduction",
      text: "The market for second-hand EVs is expected to grow rapidly in the coming years. Here's what you need to know.",
    },
    {
      heading: "Why second-hand EVs?",
      text: "Electric vehicles depreciate in value slower than their fossil-fuel counterparts, making them an excellent second-hand purchase.",
    },
    {
      heading: "What to consider",
      text: "There are a few things you should consider before buying a second-hand EV, such as the battery's health and the vehicle's range.",
    },
    {
      heading: "Conclusion",
      text: "Second-hand EVs represent an excellent opportunity for both buyers and sellers. As the market matures, expect to see a wider range of options and more competitive pricing.",
    },
  ],
};

export default mockPost;
